<template>
  <div>
    <b-button variant="info" size="sm" @click="btnClicked">
      <b-icon-pencil scale="0.8"/>
      Save as Dataset
    </b-button>
    <b-modal v-model="formModal" size="lg" button-size="sm" centered scrollable ok-title="Save" title="Save as Dataset"
             @ok="clickedSubmit">
      <b-form ref="main-form" @submit.stop.prevent="clickedSubmit">
<!--        <b-row class="mb-2">-->
<!--          <b-col>-->
<!--            <b-alert show>-->
<!--              <p class="m-0">The data will be saved.To make the data refreshable, </p>-->
<!--              <p class="m-0">set the filter for datetime to "Current Month", "Today", "Last Week", etc... </p>-->
<!--              <hr>-->
<!--              <p class="m-0">Uncheck the "Private?" checkbox to share this data in the list of Reports.</p>-->
<!--            </b-alert>-->
<!--          </b-col>-->
<!--        </b-row>-->
        <b-row class="mb-2">
          <b-col cols="12" lg="3">
            <label>Dataset Name</label>
          </b-col>
          <b-col cols="12" lg="8">
            <b-input size="sm" v-model="formItem.datasetName" max-length="200" required/>
          </b-col>
        </b-row>
<!--        <b-row class="mb-2">-->
<!--          <b-col cols="12" lg="3">-->
<!--            <label>Private?</label>-->
<!--          </b-col>-->
<!--          <b-col cols="12" lg="8">-->
<!--            <b-checkbox v-model="formItem.isPrivate" :value="true" :unchecked-value="false"/>-->
<!--          </b-col>-->
<!--        </b-row>-->
      </b-form>
    </b-modal>
  </div>
</template>

<script>
/*global _*/

const formItemDefault = {
  datasetName: '',
  datasetQuery: '',
  datasetFields: '',
  datasetCachedData: '',
  datasetLastUpdatedDateTime: '',
  isPrivate: false,
}

export default {
  //emits, btn-clicked, form-submit
  data() {
    return {
      formModal: false,
      formItem: {
        datasetName: '',
        datasetQuery: '',
        datasetFields: '',
        datasetCachedData: '',
        datasetLastUpdatedDateTime: '',
        isPrivate: false,
      },
    };
  },
  methods: {
    btnClicked() {
      this.formModal = true;
      this.formItem = _.cloneDeep(formItemDefault);
      this.$emit('btnClicked');
    },
    clickedSubmit(event) {
      const form = this.$refs["main-form"];
      if (!form.reportValidity()) {
        event.preventDefault();
        return;
      }
      this.$bvModal.msgBoxConfirm('Proceed to save the dataset?', {centered: true})
          .then((confirm) => {
            if (confirm) {
              this.$emit('formSubmitted', this.formItem);
            }
          });
    }
  }
};
</script>
